module.exports = __webpack_public_path__ + "img/photo.e2706f2c.jpg";